import { createJsonNormalizer, createShapeNormalizer } from '@change-corgi/config/fcm/normalizers';

import { createFcmConfig } from '../shared/factory';

export const FCM_REDUCED_FRICTION_PROMOTED_TO_PPMU_EXPERIMENT = createFcmConfig(
	'reduced_friction_promoted_to_ppmu_experiment',
	{
		normalizer: createJsonNormalizer(
			createShapeNormalizer({
				type: 'object',
				shape: {
					experiment_name: { type: 'string' },
				},
			}),
		),
		defaultValue: undefined,
	},
);
